/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function e({associatedLayer:e,serviceUpdateTimeStamp:t}){const n=e?.editingInfo?.lastEditDate,r=e?.serverGens,a=null!=n,i=null!=t,s=a&&i&&t.lastUpdate!==n.getTime();return a&&(s||!i&&r?.minServerGen!==r?.serverGen)}export{e as cacheIsOutOfSync};
